import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormMapComponent } from './form-map.component';
import { FormMapStateModule } from './+state/form-map-state.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MapComponent } from './map/map.component';
import { MaterialModule } from 'src/shared/material/material.module';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		FormMapStateModule,
		LeafletModule,
	],
	declarations: [FormMapComponent, MapComponent],
	exports: [FormMapComponent, MapComponent],
})
export class FormMapModule {}
